import 'babel-polyfill';

import 'nodelist-foreach-polyfill';

import objectFitImages from 'object-fit-images';

import 'classlist-polyfill';
 
import React from "react";

import ReactDOM from "react-dom";
 
import { Provider } from "react-redux";

import configureStore from './store';
 
import { BrowserRouter } from "react-router-dom";
 
import "./index.css";

import "font-awesome/css/font-awesome.min.css";
 
import { PublicClientApplication, EventType } from "@azure/msal-browser";

import { MsalProvider } from "@azure/msal-react";

import { msalConfig } from "./authConfig";

 
import App from "./App";
 
// Initialize store

export const store = configureStore();


export const msalInstance = new PublicClientApplication(msalConfig); 


msalInstance.initialize().then(() => {
  

  msalInstance.handleRedirectPromise()

    .then((response) => {

      if (response) {
        msalInstance.setActiveAccount(response.account);
      } else {
        const accounts = msalInstance.getAllAccounts();
        console.log(accounts);
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
      }
    })

    .catch((error) => {

      console.error("MSAL Redirect Error:", error);

    });
 
  
  msalInstance.addEventCallback((event) => {

    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {

      const account = event.payload.account;

      msalInstance.setActiveAccount(account);

    }

  });

 
  // object-fit fix

  objectFitImages(null, { watchMQ: true });
 
  // Your existing click handler

  const root = document.querySelector('#root');
 
  root.addEventListener('click', (e) => {

    if (e.target.tagName === 'A') {
      var storeValues = store.getState();

      if (

        e.target.getAttribute('target') == "_blank" &&

        storeValues.account.userAccountDetails != null

      ) {

        var Email = storeValues.account.userAccountDetails.PetParentInfo.Email;

        var checkUsers = sessionStorage.getItem("users");

        let userID;
 
        if (checkUsers != null && Email != null) {

          JSON.parse(checkUsers).map(item => {

            if (item.username == Email) {

              userID = item.user;

            }

          });

        }
 
        if (userID != null) {

          window.open(e.target.getAttribute("href") + "?userId=" + userID);

        }

      }

    }

  });
 
  // ✅ Render ONLY AFTER MSAL READY

  ReactDOM.render(
<BrowserRouter>
<Provider store={store}>
<MsalProvider instance={msalInstance}>
<App />
</MsalProvider>
</Provider>
</BrowserRouter>,

    document.getElementById("root")

  );
 
});
 